import { ctxOf, rasterScale } from '@/engine/canvas';

/** Fine art-pixel material accents. Geometry/alpha are never expanded. */
export function finishMaterial(canvas: HTMLCanvasElement): HTMLCanvasElement {
  if (rasterScale(canvas) < 2) return canvas;
  const ctx = ctxOf(canvas), w = canvas.width, h = canvas.height;
  const img = ctx.getImageData(0, 0, w, h), src = new Uint8ClampedArray(img.data);
  const same = (a: number, b: number) => src[b + 3] > 240 && Math.abs(src[a] - src[b]) + Math.abs(src[a + 1] - src[b + 1]) + Math.abs(src[a + 2] - src[b + 2]) < 14;
  for (let y = 1; y < h - 1; y++) for (let x = 1; x < w - 1; x++) {
    const i = (y * w + x) * 4, r = src[i], g = src[i + 1], b = src[i + 2];
    if (src[i + 3] < 240 || r + g + b < 145) continue;
    let delta = 0;
    // A narrow bevel describes the lit top and the unlit lower edge of every plane.
    if (!same(i, i - w * 4) && same(i, i + w * 4)) delta = 9;
    else if (!same(i, i + 4) && same(i, i - 4)) delta = -8;
    else if (!same(i, i + w * 4) && same(i, i - w * 4)) delta = -6;
    else if (same(i, i - 4) && same(i, i + 4) && same(i, i - w * 4)) {
      const wood = r > g * 1.13 && g > b * 1.12;
      if (wood && y % 7 === 3 && (x + Math.floor(y / 7) * 5) % 19 < 8) delta = -4;
      else if (!wood && (x + y * 3) % 23 === 0) delta = 4;
    }
    if (delta) {
      img.data[i] = Math.max(0, Math.min(255, r + delta));
      img.data[i + 1] = Math.max(0, Math.min(255, g + delta));
      img.data[i + 2] = Math.max(0, Math.min(255, b + delta));
    }
  }
  ctx.putImageData(img, 0, 0);
  return canvas;
}
